import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Icon, IconColor, IconID } from '@hub/common/Icon/Icon';

export interface DialogProps {
  visible: boolean;
  closable?: boolean;
  fullScreen?: boolean;
  children?: ReactNode;

  onClose?(): void;

  onSetFullScreen?(isFullScreen: boolean): void;
}

export const Dialog = ({ visible = false, closable, fullScreen, onClose, onSetFullScreen, children }: DialogProps) => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleFullScreenToggle = () => {
    setIsFullScreen(!isFullScreen);
    onSetFullScreen?.(!isFullScreen);
  };

  const handleDialogClose = () => {
    window.document.body.classList.remove('overflow-hidden');
    onClose();
  };
  useEffect(() => {
    window.document.body.classList[visible ? 'add' : 'remove']('overflow-hidden');
  }, [visible]);

  const fullScreenButton = (
    <button
      type="button"
      onClick={handleFullScreenToggle}
      className={classNames('bg-gray-200 w-16 h-16 hidden lg:block')}
    >
      <Icon size={12} id={isFullScreen ? IconID.FULL_SCREEN_EXIT : IconID.FULL_SCREEN_OPEN} color={IconColor.WHITE} />
    </button>
  );

  const closeButton = (
    <button
      type="button"
      data-testid="dialog-close-icon"
      onClick={handleDialogClose}
      className={classNames('bg-gray-200 w-16 h-16')}
    >
      <Icon size={6} color={IconColor.WHITE} id={IconID.CLOSE_CROSS} />
    </button>
  );

  const dialogButtons = (
    <div className="flex  gap-2.5 absolute top-0 right-0 p-6">
      {fullScreen && fullScreenButton}
      {closable && closeButton}
    </div>
  );

  return visible ? (
    <div
      role="dialog"
      className="flex justify-center items-center fixed top-0 left-0 bottom-0 right-0 z-50 bg-gray-600 bg-opacity-60"
    >
      <div
        data-testid="dialog-container"
        className={`bg-white relative flex flex-row ${
          isFullScreen ? 'w-screen h-screen' : 'max-w-[100vw] max-h-[100vh]'
        }`}
      >
        {closable && dialogButtons}
        {children}
      </div>
    </div>
  ) : null;
};
